'use strict';

(function ($) {
  var methods = {
    init: function (options) {
      var opts = $.extend({}, $.fn.k2_filterClear.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('filter-clear-init')) {
          return;
        }

        $this.addClass('filter-clear-init');

        $this.on('click', '.clear-filter', function () {
          $this.find('input:visible').val('');
          $this.find('input.clear-hidden-input').val('');
          $this.find('select:visible').find('option:selected').prop('selected', false);
          $this.find('select:visible').change();
          $this.find('.lookup input').val('');

          if (opts.callBack) {
            opts.callBack($this);
          }

          $this.trigger('filter-clean');

          return false;
        });
      });
    }
  };

  $.fn.k2_filterClear = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_filterClear');
    }

  };

  $.fn.k2_filterClear.defaults = {
    callBack: function ($form) {
      $form.trigger('submit');
    }
  };

})(jQuery);
